export default __webpack_public_path__ + "static/media/Print-08.d5c88d53.svg";